import { render, staticRenderFns } from "./ListItemsController.vue?vue&type=template&id=e89d2a8a&scoped=true"
import script from "./ListItemsController.vue?vue&type=script&lang=js"
export * from "./ListItemsController.vue?vue&type=script&lang=js"
import style0 from "./ListItemsController.vue?vue&type=style&index=0&id=e89d2a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89d2a8a",
  null
  
)

export default component.exports